/**
 * Query-key factory for the Requirement Tests module. Mirrors the
 * Requirements module's shape.
 *
 * Test data lives inside `Requirement.body.tests` on the backend, so
 * the source of truth is actually the `requirementKeys.spec(projectId)`
 * cache entry. We keep a separate key namespace anyway for two reasons:
 *
 *   1. `useRequirementTests(projectId, publicId)` is a focused read
 *      that doesn't need the whole spec; the hook either derives from
 *      the spec cache (when present) or hits `GET /tests` directly.
 *   2. Test-run artefacts can invalidate this key independently when
 *      they complete, without churning the spec query.
 */
export const requirementTestsKeys = {
  all: ["requirement-tests"] as const,
  forRequirement: (projectId: string, publicId: string) =>
    [...requirementTestsKeys.all, projectId, publicId] as const,
};
